import { useCallback } from 'react';

import { DictionaryTypeDto } from '@/api/generated';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';

/** Translated dictionary type name; no requests, safe where entries must not load. */
export const useDictionaryTypeLabel = (): ((type: DictionaryTypeDto) => string) => {
  const { t } = useTranslationWithPrefix('utils.dictionaries');

  return useCallback((type: DictionaryTypeDto) => t(`dictionaryTypeOptions.${type}`), [t]);
};
